type GetDropHeadingParams = {
  isReminderSet: boolean;
  isAuth: boolean;
  isPostLaunch: boolean;
  firstName: string;
  tShop: (key: string, values?: Record<string, string>) => string;
};

type GetDropCaptionParams = {
  isReminderSet: boolean;
  isAuth: boolean;
  isPostLaunch: boolean;
  tShop: (key: string, values?: Record<string, string>) => string;
};

export function getDropHeading({
  isReminderSet,
  isAuth,
  isPostLaunch,
  firstName,
  tShop,
}: GetDropHeadingParams): string {
  if (isReminderSet) {
    return tShop('DropReminderSetHeading', { firstName });
  }

  if (isAuth) {
    return isPostLaunch
      ? tShop('DropPostLaunchHeadingAuth', { firstName })
      : tShop('DropCountdownHeadingAuth', { firstName });
  }

  if (!isPostLaunch) {
    return tShop('DropCountdownHeadingAuth', { firstName });
  }

  return tShop('DropPostLaunchHeadingGuest', { firstName });
}

export function getDropCaption({
  isReminderSet,
  isAuth,
  isPostLaunch,
  tShop,
}: GetDropCaptionParams): string {
  if (isReminderSet) {
    return tShop('DropReminderSetCaption');
  }

  if (!isPostLaunch) {
    return tShop('DropRemindMeCaption');
  }

  if (isAuth) {
    return tShop('DropPostLaunchCaptionAuth');
  }

  return tShop('DropPostLaunchCaptionGuest');
}
